<div class="hemro-drawer-content">
    <ng-content></ng-content>
</div>
